import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Attach the inspector's JWT to outgoing `/api/*` requests, except the login endpoints
 * (which don't need a token and shouldn't be redirected on 401 — they have their own
 * UX for "wrong password").
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.startsWith('/api/')) {
        return next(req);
    }
    const isLoginCall = req.url.startsWith('/api/auth/login-');

    const auth = inject(AuthService);
    const router = inject(Router);

    const jwt = auth.jwt();
    const authedReq = !isLoginCall && jwt ? req.clone({ setHeaders: { Authorization: `Bearer ${jwt}` } }) : req;

    return next(authedReq).pipe(
        catchError((err) => {
            if (err instanceof HttpErrorResponse && err.status === 401 && !isLoginCall) {
                auth.clearSession();
                router.navigate(['/login']);
            }
            return throwError(() => err);
        })
    );
};
